import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MessageSuccess from "../../../../messages/messageSuccess";
import MessageError from "../../../../messages/messageError";
import { useNavigate, useParams } from "react-router-dom";
import CardDepartamentos from "./cardAreas";
import FazerObservacoes from "../../../components/fazerObservacoes.";
import api from "../../../../services/api";
import * as yup from 'yup';
import RegisterAccess from "../../../../utils/registerAccess";
import ButtonLeft from "../../../../utils/buttonLeft";

export default function ChangeStatus({ estabelecimento }) {
  const { id, encaminhar, status } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector(state => state.account.user);
  const baseUrl = window.location.origin;

  const [messageSuccess, setMessageSuccess] = useState('');
  const [messageError, setMessageError] = useState('');
  const [open, setOpen] = useState(false);
  const [obs, setObs] = useState('');

  const isApprove = encaminhar === 'approve';

  const changeStatus = async () => {
    setOpen(true);
    setMessageSuccess('');
    setMessageError('');

    await api.patch('/estabelecimento/change-status', {
      estabelecimentoId: id, status, userId: user._id,
    }).then(res => {
      setOpen(false);
      setMessageSuccess(res.data.msg);
      if (obs) HandleCreateobservacao();
      if (status === 'Inspecção Agendada' || status === 'Reprovado') senEmail();

      dispatch({ type: 'alert', payload: { alert: 'Processo encaminhado com sucesso.' } });

      window.setTimeout(() => {
        navigate(localStorage.getItem('urlAnterior') || -1);
      }, 3000);
    }).catch(err => {
      setOpen(false);
      setMessageError(err.response.data.message);
    });
  };

  async function senEmail() {
    const msgLic = {
      to: estabelecimento?.email,
      subject: 'Estado da solicitação de licenciamento de estabelecimento farmacêutico',
      html: `<h1>O processo está no estado: ${status}</h1>
      <p>Este é um email de acompanhamento da solicitação de licenciamento do estabelecimento <b>${estabelecimento?.nome}</b> com o número de entrada <b>${estabelecimento?.numeroEntrada}</b> que submeteu na <b>ARMED</b></p>
      ${status === 'Reprovado' ? `<p>Observação:<br/>${obs}</p><p>Para fazer as devidas alterações aceda ao link abaixo:</p><a href='${baseUrl}/edite-processo-estabelecimento/${estabelecimento._id}'>Processo_${estabelecimento?.nome}</a>` : ''}
      <p><b>Nota:</b> Este e-mail foi gerado automaticamente pela plataforma <b>ARMED</b></p>`,
    };
    const msgRen = {
      to: estabelecimento?.email,
      subject: 'Estado da solicitação de renovação de autorização de exercício',
      html: `<h1>O processo está no estado: ${status}</h1>
      <p>Este é um email de acompanhamento da solicitação de renovação de autorização de exercício para o estabelecimento <b>${estabelecimento?.nome}</b> que submeteu na <b>ARMED</b></p>
      ${status === 'Reprovado' ? `<p>Observação:<br/>${obs}</p><p>Para fazer as devidas alterações acesse o link abaixo:</p><a href='${baseUrl}/edite-processo-estabelecimento/${estabelecimento._id}'>Processo_${estabelecimento?.nome}</a>` : ''}
      <p><b>Nota:</b> Este e-mail foi gerado automaticamente pela plataforma <b>ARMED</b></p>`,
    };
    api.post('/email/send', estabelecimento?.tipoEntrada === 'Licenciamento' ? msgLic : msgRen).catch(() => { });
  }

  async function HandleCreateobservacao() {
    setOpen(true);
    setMessageError('');
    setMessageSuccess('');
    await api.post('/observacao/create', {
      assunto: isApprove ? 'Aprovação de licenciamento' : 'Reprovação de licenciamento',
      descricao: obs,
      userId: user._id,
      estabelecimentoId: id,
    }).then(res => {
      setOpen(false);
      setMessageSuccess(res.data.msg);
    }).catch(error => {
      setMessageError(error.response.data.message);
      setOpen(false);
    });
  }

  async function validate() {
    setMessageError('');
    const schema = yup.object().shape({
      observacao: yup.string().required('Necessário inserir observações'),
    });
    try {
      await schema.validate({ observacao: obs });
      changeStatus();
    } catch (error) {
      setMessageError(error.errors);
    }
  }

  return (
    <div className="tw-bg-white tw-rounded-xl tw-border tw-border-gray-100 tw-shadow-sm tw-p-6">
      <RegisterAccess page={'alteração de estado de estabelecimento'} />

      {messageSuccess && <MessageSuccess message={messageSuccess} />}
      {messageError && <MessageError message={messageError} />}

      {/* ── Confirmação ── */}
      <div className="tw-mb-6">
        <h2 className="tw-text-lg tw-font-bold tw-text-gray-800 tw-mb-1">
          Confirmação de {isApprove ? 'aprovação' : 'reprovação'}
        </h2>
        <div className="tw-h-px tw-bg-gray-100 tw-mb-4" />

        {isApprove && (
          <p className="tw-text-sm tw-text-gray-600 tw-mb-4 tw-leading-relaxed">
            Ao confirmar esta acção estará a afirmar que analisou correctamente toda a informação
            e documentos anexados neste processo estão em conformidade.
          </p>
        )}

        <FazerObservacoes
          setObs={setObs}
          obs={obs}
          titulo={isApprove ? '(caso seja necessário fazer alguma observação)' : '(Descreve os motivos desta reprovação)'}
        />


          <ButtonLeft
            title={'Confirmar'}
            funcao={isApprove ? changeStatus : validate}
            load={open}
          >

            <button
              onClick={() => navigate(`/admin/analise/solicitacao-de-licenciamento/${id}`)}
              className="tw-border-none tw-text-sm tw-font-semibold tw-text-red-500 hover:tw-text-red-600 tw-transition-colors tw-duration-200 tw-p-2 tw-rounded-lg"
            >
              Cancelar
            </button>
          </ButtonLeft>

      </div>

      {/* ── Fluxo do processo ── */}
      <h2 className="tw-text-lg tw-font-bold tw-text-gray-800 tw-mb-1">
        O processo será encaminhado para:
      </h2>
      <div className="tw-h-px tw-bg-gray-100 tw-mb-5" />

      <div className="tw-flex tw-flex-wrap tw-justify-center tw-gap-5">
        <CardDepartamentos fase={'Analisado'} icone={'/icones/chefedaSeccao.svg'} nomeService={'Chefe da Área'} />
        <CardDepartamentos fase={'Analisado Chefe de Secção'} icone={'/icones/chefeDepartamento.svg'} nomeService={'Chefe do Departamento'} />
        <CardDepartamentos fase={'Inspecção Agendada'} icone={'/icones/inspeccaoAgendarVisita.svg'} nomeService={'Inspecção'} />
        <CardDepartamentos fase={'Inspecção Realizada'} icone={'/icones/chefeDepartamento.svg'} nomeService={'Análise da Inspecção'} />
        <CardDepartamentos fase={'Deferimento'} icone={'/icones/diretoraGeral.svg'} nomeService={'Directora(a) Geral'} />
      </div>
    </div>
  );
}
